<template>
<div>

	<div class="page-header">
		<h1 v-if="!isLoading">
            <template v-if="!manufacturer.id"><lang labelKey="MANUFACTURER-HEADER-NEW_MANUFACTURER"></lang></template>
            <template v-else>{{ manufacturer.name }}</template>
        </h1>
	</div>

	<div class="columns">

		<div class="col-main">

			<template v-if="isLoading">
				<div class="loadingContainer has-text-centered">
					<loading-indicator></loading-indicator>
				</div>
			</template>

            <template v-else>

                <div class="box">

					<form-input label="MANUFACTURER-EXTREF" :inputType="text" v-model="manufacturer.extRef" :is-horizontal="true"></form-input>
					<form-input label="MANUFACTURER-NAME" :inputType="text" v-model="manufacturer.name" :is-horizontal="true"></form-input>

					<br />

					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="MANUFACTURER-NEWSLETTER-ACTIVE"></label-name>
						</div>
						<div class="control">
							<b-switch v-model.sync="manufacturer.isManufacturerNewsNewsletterRecipient" type="primary" size="small" :disabled="isReadOnly"></b-switch>
						</div>
					</div>

					<template v-if="manufacturer.isManufacturerNewsNewsletterRecipient">
						<form-input label="MANUFACTURER-NEWSLETTER-GENDER" :showLabel="true" :showLabelInOptions="true" inputType="select" selectFieldName="name" :selectOptions="personGenders" v-model="manufacturer.manufacturerNewsNewsletterRecipient.gender" :is-horizontal="true"></form-input>
						<form-input label="MANUFACTURER-NEWSLETTER-TITLE" :inputType="text" v-model="manufacturer.manufacturerNewsNewsletterRecipient.title" :is-horizontal="true"></form-input>
						<form-input label="MANUFACTURER-NEWSLETTER-FIRSTNAME" :inputType="text" v-model="manufacturer.manufacturerNewsNewsletterRecipient.firstname" :is-horizontal="true"></form-input>
						<form-input label="MANUFACTURER-NEWSLETTER-LASTNAME" :inputType="text" v-model="manufacturer.manufacturerNewsNewsletterRecipient.lastname" :is-horizontal="true"></form-input>
						<form-input label="MANUFACTURER-NEWSLETTER-EMAIL" :inputType="text" v-model="manufacturer.manufacturerNewsNewsletterRecipient.email" :is-horizontal="true"></form-input>

						<div class="control is-horizontal" v-if="manufacturer.manufacturerNewsNewsletterRecipient.createdBy != null">
							<div class="control-label"></div>
							<div class="control"><small>hinzugefügt von {{ (manufacturer.manufacturerNewsNewsletterRecipient.createdBy.person != null ? manufacturer.manufacturerNewsNewsletterRecipient.createdBy.person.fullName : manufacturer.manufacturerNewsNewsletterRecipient.createdBy.username) }} am {{ formatDate2(manufacturer.manufacturerNewsNewsletterRecipient.createdAt) }}</small></div>
						</div>

					</template>

                </div>

            </template>


        </div>

        <div class="col-aside">

            <div class="sidebox">
                <affix :offset="0" boundary=".col-aside">
					<custom-button type="blue" icon="icon-ak-speichern" name="MANUFACTURER-BTN_SAVE" :loading="isSaving" @click.native="submitForm"></custom-button>
                </affix>
            </div>


        </div>

    </div>

</div>

</template>


<script>
export default {

	data() {

		return {
            isLoading: false,
            isSaving: false,
            manufacturer: {}
        }

    },

	created() {

        var manufacturerId = parseInt(this.$route.params.manufacturerID);

        if (manufacturerId && Number.isInteger(manufacturerId)) {

			var self = this;

            // this.entityGet('manufacturer', manufacturerId, {}, 'manufacturer');
			this.axios.get(this.$config.api + 'manufacturer/'+manufacturerId+'?include=manufacturer.manufacturerNewsNewsletterRecipient,person.gender,person.createdBy')
				.then((response) => {
					self.manufacturer = response.data;
				})
        }

        // fetch the ID from router
		/*if(this.$route.params.manufacturerID && Number.isInteger(parseInt(this.$route.params.manufacturerID)) ) {

			this.isLoading=true;
			this.fetchData();

		// no (valid) apo ID or new
		} else {

            this.isNewManufacturer = true;

		}*/

    },

	computed: {

		personGenders() {
			return this.$store.getters.getTermsByTaxonomy('PERSON_GENDERS');
		},

	},

	watch: {

		'manufacturer.isManufacturerNewsNewsletterRecipient'(val) {

			if(val == true && this.manufacturer.manufacturerNewsNewsletterRecipient == null) {

				this.manufacturer.manufacturerNewsNewsletterRecipient = {
					email: '',
					firstname: '',
					lastname: '',
					title: '',
					gender: ''
				}
			}
		}

	},


    methods: {

        submitForm() {

            var self = this;

            this.entityCreateOrUpdate('manufacturer', this.manufacturer)
                .then(function(response) {

					console.log("response: ", response);
                    // self.$router.push({ path: '/einstellungen/hersteller' });

                });
        },

    }
}

</script>
